export default {
  title: 'Payment Gateways',
  fields: {
    name: 'Name',
    payment_gateway: 'Payment Gateways',
    live_from: 'Live Since',
    last_30_days_sales: 'Last 30 Days Sales',
    kyc_deadlines: 'KYC Deadlines',
    actions: 'Actions',
  },
  stats: {
    active_on_stripe: 'Active on Stripe',
    active_on_adyen: 'Active on Adyen',
    adyen_verification_pending: 'Adyen Verification Pending',
  },
  filters: {
    search_placeholder: 'Search by name...',
    gateway_status_placeholder: 'All gateways',
  },
  not_configured: {
    title: 'Payments are not configured yet',
    description:
      'No payment provider is connected for your account. Restaurants can be fully set up, but they cannot go live or accept online payments until payments are configured.',
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (Pending)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Verified',
    pending: 'Pending',
    rejected: 'Rejected',
  },
  buttons: {
    actions: 'Actions',
    switch_to: 'Switch to {{gateway}}',
    view_details: 'View details',
    open_onboarding: 'Open onboarding',
    create_onboarding_link: 'Create onboarding link',
  },
  modal: {
    title: 'Switch Payment Gateway',
    description:
      'Are you sure you want to switch {{companyName}} from <bold>{{currentGateway}}</bold> to <bold>{{targetGateway}}</bold>?',
    not_verified_warning: '{{gateway}} is not verified for this company. Payment processing may be affected.',
    confirm: 'Switch',
    cancel: 'Cancel',
  },
  details_modal: {
    title: '{{companyName}} — Payment Gateway Details',
    requirements: 'Requirements',
    no_requirements: 'No pending requirements.',
    deadline: 'Deadline',
    capabilities: 'Capabilities',
    onboarding_links: {
      section_title: 'Onboarding Link',
      active_link: 'Active link',
      expires: 'Expires {{date}}',
      create_button: 'Create link',
      extend_button: 'Extend link',
      loading: 'Loading links…',
    },
  },
  toasts: {
    onboarding_link_failed: 'Failed to create onboarding link.',
    switch_success: 'Payment gateway switched successfully.',
    switch_failed: 'Failed to switch payment gateway.',
    failed_to_load_data: 'Failed to load data.',
  },
};
